import { createSelector, createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import { userSelector } from 'selectors/user/userSelector';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import AdvocacySuccessEN from 'components/Campaigns/RwdAdvocacy/AdvocacyViews/AdvocacySuccess/locales/AdvocacySuccess_en_US';
import AdvocacySuccessFR from 'components/Campaigns/RwdAdvocacy/AdvocacyViews/AdvocacySuccess/locales/AdvocacySuccess_fr_CA';

const { getLocalisedDataFromResource, getTextFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(AdvocacySuccessEN, AdvocacySuccessFR);

const { wrapHOC } = FrameworkUtils;

const localization = createStructuredSelector({
    yourNextPurchase: getTextFromResource(getText, 'yourNextPurchase'),
    redemptionInstructions: getTextFromResource(getText, 'redemptionInstructions'),
    barcodeScan: getTextFromResource(getText, 'barcodeScan'),
    shopNow: getTextFromResource(getText, 'shopNow'),
    redeemOnline: getTextFromResource(getText, 'redeemOnline'),
    valid: getTextFromResource(getText, 'valid'),
    promoReminder: getTextFromResource(getText, 'promoReminder')
});

const fields = createSelector(userSelector, localization, (user, locales) => {
    return {
        user,
        locales
    };
});

const functions = null;

const withAdvocacySuccessProps = wrapHOC(connect(fields, functions));

export {
    withAdvocacySuccessProps, fields, functions
};
